import { useEffect } from 'react';
import { useAdConfig } from '../hooks/useAdConfig';

interface InFeedAdProps {
  slot: string;
}

/**
 * In-feed ad that blends with post content
 */
export default function InFeedAd({ slot }: InFeedAdProps) {
  const { showAdsForCurrentUser } = useAdConfig();
  const clientId = import.meta.env.VITE_ADSENSE_CLIENT_ID || 'ca-pub-1126182424925466';

  useEffect(() => {
    if (!showAdsForCurrentUser) return;
    try {
      if (window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (err) {
      console.error('InFeedAd error:', err);
    }
  }, [showAdsForCurrentUser]);

  // Don't render if ads are disabled for this user
  if (!showAdsForCurrentUser) {
    return null;
  }

  return (
    <div style={{
      width: '100%',
      margin: '20px 0',
      padding: '16px',
      backgroundColor: 'rgba(17, 66, 50, 0.05)',
      borderRadius: '12px',
      border: '1px solid rgba(17, 66, 50, 0.2)',
    }}>
      <div style={{
        fontSize: '11px',
        color: '#666',
        marginBottom: '8px',
        textAlign: 'center',
      }}>
        Reklam
      </div>
      <ins
        className="adsbygoogle"
        style={{
          display: 'block',
        }}
        data-ad-format="fluid"
        data-ad-layout-key="-fb+5w+4e-db+86"
        data-ad-client={clientId}
        data-ad-slot={slot}
      />
    </div>
  );
}

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}
